export default function fieldSort(a, b) {
	return a.sortId - b.sortId || a.id - b.id;
}
